const QUINYX_ALFA_ID = "quinyx";

export default {
  getParameterValue(name) {
    let value;
    if (process.env.ALFA_ID === QUINYX_ALFA_ID) {
      value = config[name];
    } else {
      value = process.vars[name];
    }
    return value;
  },
};



// WEBPACK FOOTER //
// ./src/helpers/params.js